type BadgeVariant = 'brand' | 'neutral' | 'error' | 'warning' | 'success';

interface SearchStatusConfig {
  label: string;
  variant: BadgeVariant;
}

const PROCESSO_STATUS_CONFIG: Record<string, SearchStatusConfig> = {
  RASCUNHO: { label: 'Rascunho', variant: 'neutral' },
  EM_ANALISE: { label: 'Em Análise', variant: 'brand' },
  AGUARDANDO_DOCUMENTOS: { label: 'Aguardando Documentos', variant: 'warning' },
  AGUARDANDO_ASSINATURA: { label: 'Aguardando Assinatura', variant: 'warning' },
  PRONTO_DISTRIBUICAO: { label: 'Pronto p/ Distribuição', variant: 'brand' },
  PROTOCOLADO: { label: 'Protocolado', variant: 'brand' },
  DISTRIBUIDO: { label: 'Distribuído', variant: 'brand' },
  EM_ANDAMENTO: { label: 'Em Andamento', variant: 'brand' },
  CONCLUIDO: { label: 'Concluído', variant: 'success' },
  FINALIZADO: { label: 'Finalizado', variant: 'success' },
  CANCELADO: { label: 'Cancelado', variant: 'error' },
  PROCESSO_DISTRIBUIDO: { label: 'Processo Distribuído', variant: 'warning' },
  TRIAGEM_EM_ANDAMENTO: { label: 'Triagem em Andamento', variant: 'brand' },
  TRIAGEM_CONCLUIDA: { label: 'Triagem Concluída', variant: 'brand' },
  EM_CITACAO: { label: 'Em Citação', variant: 'brand' },
  SENTENCA_EMITIDA: { label: 'Sentença Emitida', variant: 'success' },
  NEGADO: { label: 'Negado', variant: 'error' },
};

const NOTIFICACAO_STATUS_CONFIG: Record<string, SearchStatusConfig> = {
  RASCUNHO: { label: 'Rascunho', variant: 'neutral' },
  AGUARDANDO_ENVIO: { label: 'Aguardando Envio', variant: 'brand' },
  AGENDADA: { label: 'Agendada', variant: 'warning' },
  EM_PROCESSAMENTO: { label: 'Em Processamento', variant: 'brand' },
  ENVIANDO: { label: 'Enviando', variant: 'brand' },
  ENVIADA: { label: 'Enviada', variant: 'brand' },
  PARCIALMENTE_ENVIADA: { label: 'Parcialmente Enviada', variant: 'warning' },
  FALHA_ENVIO: { label: 'Falha no Envio', variant: 'error' },
  ENTREGUE: { label: 'Entregue', variant: 'success' },
  PARCIALMENTE_ENTREGUE: { label: 'Parcialmente Entregue', variant: 'warning' },
  VISUALIZADA: { label: 'Visualizada', variant: 'success' },
  EM_NEGOCIACAO: { label: 'Em Negociação', variant: 'brand' },
  CONCLUIDA: { label: 'Concluída', variant: 'success' },
  CANCELADA: { label: 'Cancelada', variant: 'neutral' },
  ARQUIVADA: { label: 'Arquivada', variant: 'neutral' },
  REENVIADA: { label: 'Reenviada', variant: 'brand' },
};

const NEGOCIACAO_STATUS_CONFIG: Record<string, SearchStatusConfig> = {
  SCHEDULED: { label: 'Agendada', variant: 'warning' },
  NEGOTIATION_STARTED: { label: 'Negociação iniciada', variant: 'brand' },
  ACTIVE: { label: 'Negociação ativa', variant: 'success' },
  AGREEMENT_CLOSED: { label: 'Acordo Fechado', variant: 'success' },
  NO_AGREEMENT: { label: 'Sem Acordo', variant: 'error' },
  PAUSED: { label: 'Pausada', variant: 'neutral' },
  ARCHIVED: { label: 'Arquivada', variant: 'neutral' },
  CLOSED: { label: 'Encerrada', variant: 'neutral' },
};

const PETICIONAMENTO_STATUS_CONFIG: Record<string, SearchStatusConfig> = {
  RASCUNHO: { label: 'Rascunho', variant: 'neutral' },
  AGUARDANDO_ENVIO: { label: 'Aguardando Envio', variant: 'warning' },
  ENVIADO: { label: 'Enviado', variant: 'brand' },
  EM_PROCESSAMENTO: { label: 'Em Processamento', variant: 'brand' },
  CONCLUIDO: { label: 'Concluído', variant: 'success' },
  ERRO: { label: 'Erro', variant: 'error' },
};

const DOCUMENTO_STATUS_CONFIG: Record<string, SearchStatusConfig> = {
  PENDENTE: { label: 'Pendente', variant: 'warning' },
  PROCESSANDO: { label: 'Processando', variant: 'brand' },
  PROCESSADO: { label: 'Processado', variant: 'success' },
  ERRO: { label: 'Erro', variant: 'error' },
};

type SearchEntityType = 'processo' | 'notificacao' | 'negociacao' | 'peticionamento' | 'documento';

const STATUS_CONFIG_MAP: Record<SearchEntityType, Record<string, SearchStatusConfig>> = {
  processo: PROCESSO_STATUS_CONFIG,
  notificacao: NOTIFICACAO_STATUS_CONFIG,
  negociacao: NEGOCIACAO_STATUS_CONFIG,
  peticionamento: PETICIONAMENTO_STATUS_CONFIG,
  documento: DOCUMENTO_STATUS_CONFIG,
};

const DEFAULT_STATUS_CONFIG: SearchStatusConfig = { label: '', variant: 'neutral' };

export const getSearchStatusConfig = (
  type: SearchEntityType,
  status: string,
): SearchStatusConfig => {
  const config = STATUS_CONFIG_MAP[type]?.[status];
  if (config) return config;
  return { ...DEFAULT_STATUS_CONFIG, label: status };
};
